import React from "react";
import { siteConfig } from "../Datas/productData";
import PolicyNav, { POLICY_UPDATED } from "./PolicyNav";
import "../css/privacy.scss";

export default function Accessibility() {
  return (
    <main className="policy-page privacy">
      <header className="policy-hero policy-hero--legal">
        <p className="policy-eyebrow">Accessibility</p>
        <h1>Accessibility statement</h1>
        <p>
          Our commitment to making the {siteConfig.brandName} storefront useful
          for as many people as possible.
        </p>
        <span>Last reviewed {POLICY_UPDATED}</span>
      </header>

      <div className="policy-layout">
        <PolicyNav current="/accessibility" />

        <article className="policy-content policy-content--legal">
          <section className="policy-intro" aria-labelledby="accessibility-overview">
            <p className="policy-eyebrow">Our commitment</p>
            <h2 id="accessibility-overview">A storefront designed for access.</h2>
            <p>
              We are working toward the Web Content Accessibility Guidelines
              (WCAG) 2.2 Level AA as a practical benchmark. Accessibility is an
              ongoing process, so this statement describes our goal rather than
              claiming that every page or third-party service is fully conformant.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="accessibility-features">
            <div className="policy-section__heading">
              <span>01</span>
              <h2 id="accessibility-features">Features we support</h2>
            </div>
            <ul>
              <li>keyboard navigation and visible focus indicators;</li>
              <li>a skip link and semantic headings and landmarks;</li>
              <li>labels, instructions, and error messages for form controls;</li>
              <li>alternative text for meaningful images;</li>
              <li>responsive layouts and text that can be enlarged; and</li>
              <li>reduced animation when a device requests reduced motion.</li>
            </ul>
          </section>

          <section className="policy-section" aria-labelledby="accessibility-limitations">
            <div className="policy-section__heading">
              <span>02</span>
              <h2 id="accessibility-limitations">Known limitations</h2>
            </div>
            <p>
              Payment and some delivery experiences may be operated by independent
              providers whose accessibility we do not fully control. Product
              photography can also communicate visual detail that is difficult
              to capture completely in short text. Contact us for product details
              or assistance completing an order through an available alternative.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="accessibility-feedback">
            <div className="policy-section__heading">
              <span>03</span>
              <h2 id="accessibility-feedback">Request help or report a barrier</h2>
            </div>
            <p>
              Email {siteConfig.contact.email} with the page address, what you
              were trying to do, the barrier you encountered, and—if you are
              comfortable sharing it—your browser, device, and assistive
              technology. Tell us your preferred accessible format or contact
              method. We aim to acknowledge accessibility messages within five
              business days.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="accessibility-improvement">
            <div className="policy-section__heading">
              <span>04</span>
              <h2 id="accessibility-improvement">Ongoing improvement</h2>
            </div>
            <p>
              We review important shopping paths, consider accessibility when
              making design and code changes, and prioritize barriers according
              to their impact. Feedback helps us identify issues that automated
              checks and internal review can miss. We will update this statement
              as meaningful improvements or limitations change.
            </p>
          </section>

          <section className="policy-help" aria-labelledby="accessibility-help">
            <div>
              <p className="policy-eyebrow">Accessibility help</p>
              <h2 id="accessibility-help">Tell us what you need.</h2>
            </div>
            <a href={`mailto:${siteConfig.contact.email}`}>
              {siteConfig.contact.email} <span aria-hidden="true">↗</span>
            </a>
          </section>
        </article>
      </div>
    </main>
  );
}
